import React, { useContext, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import usePromotionalSalesPages from '../senior-portraits-review/usePromotionalSalesPages';
import Container from '../../v2/Container';
import Yearbooks from './Yearbooks';
import { CustomerContext } from '../../../contexts/CustomerContext';
import routes from '../../../routes';
import Button from '../../Button';
import Panoramas from './Panoramas';
import { ToastContainer, toast } from 'react-toastify';
import { PackageLandingContent } from '../_landing/Package/PackageLanding';

export default function Promos() {
  const { packageId } = useParams();
  const history = useHistory();
  const { customer } = useContext(CustomerContext);
  const { data } = usePromotionalSalesPages(packageId, customer.currentSchool.id, customer.currentStudent && customer.currentStudent.studentId, customer.cart && customer.cart.id);
  const [index, setIndex] = useState(0);
  const [hasAddedItem, setHasAddedItem] = useState(false);

  const displayablePages = data.filter((promoPage) => promoPage.schoolHasAssociatedPackage && !promoPage.studentHasPurchasedPackage && promoPage.promoItem !== 'composite');

  const decrement = () => {
    setIndex((prev) => Math.max(prev - 1, 0));
  };

  const increment = () => {
    setIndex((prev) => Math.min(displayablePages.length - 1, prev + 1));
  };

  const onAdd = () => {
    toast.success('Thank you! Your item has been added to your cart.', { position: 'top-center', autoClose: 2000 });
    setTimeout(() => increment(), 250);
    setHasAddedItem(true);
  };

  const onLastItem = index === displayablePages.length - 1;

  return (
    <Container maxWidth="lg">
      <ToastContainer />
      {displayablePages.map((promoPage, i) => {
        if (promoPage.promoItem === 'digital_images') {
          return (
            <div key={promoPage.id} style={{ display: i === index ? 'block' : 'none' }}>
              <PackageLandingContent
                afterAdd={onAdd}
                optionId={promoPage.digitalOptionId}
                packageId={packageId}
                pushToNextRoute={false}
                studentId={customer.currentStudent.id}
              />
            </div>
          );
        }

        if (promoPage.promoItem === 'yearbook') {
          return (
            <div key={promoPage.id} style={{ display: i === index ? 'block' : 'none' }}>
              <Yearbooks afterAdd={onAdd} />
            </div>
          );
        }

        if (promoPage.promoItem === 'composite') {
          return (
            <div key={promoPage.id} style={{ display: i === index ? 'block' : 'none' }}>
              <Yearbooks afterAdd={onAdd} />
            </div>
          );
        }

        if (promoPage.promoItem === 'panorama') {
          return (
            <div key={promoPage.id} style={{ display: i === index ? 'block' : 'none' }}>
              <Panoramas afterAdd={onAdd} />
            </div>
          );
        }

        return null;
      })}
      {displayablePages.length > 0 && displayablePages.length > 1 && (
        <div style={{ display: 'flex', gap: '24px', margin: '24px auto' }}>
          <Button onClick={decrement}>Previous</Button>
          <Button
            onClick={() => {
              if (onLastItem) history.push(routes.review());

              increment();
            }}
          >
            {onLastItem ? 'Review Order' : 'Next'}
          </Button>
        </div>
      )}
      {displayablePages.length > 0 && (
        <div style={{ margin: '2rem 0' }}>
          <Link to={routes.review()}>
            <Button fullWidth variant="submit">
              {hasAddedItem ? '' : 'No thank you, '}
              {hasAddedItem ? 'Continue ' : 'continue '}
              to review order
            </Button>
          </Link>
        </div>
      )}
    </Container>
  );
}
